import React, { Component } from "react";
import Axios from "axios";
import { withTranslation } from "react-i18next";
import { ToastContainer, Flip } from "react-toastify";
import { FaUser, FaLock, FaSignInAlt, FaSpinner } from "react-icons/fa";
import logo from "../../images/modon.png";
import "../../styles/modern.css";

class LoginForm extends Component {
  state = {
    Username: "",
    Password: "",
    isLoading: false,
    errDesc: "",
  };

  componentDidMount() {
    const handleEnter = (id) => {
      document.getElementById(id)?.addEventListener("keyup", (e) => {
        if (e.keyCode === 13) document.getElementById("btnLogin")?.click();
      });
    };
    handleEnter("username");
    handleEnter("password");
  }

  changeLanguage = (lng) => {
    const { i18n } = this.props;
    i18n.changeLanguage(lng);
    localStorage.setItem("cma_language", lng);
  };

  handleLogin = () => {
    const { t } = this.props;
    this.setState({ isLoading: true, errDesc: "" });

    if (!this.state.Username || !this.state.Password) {
      this.setState({ errDesc: t("login.enterCredentials"), isLoading: false });
      return;
    }

    Axios.post("/api/account/dashboardlogin", {
      username: this.state.Username,
      password: this.state.Password,
    })
      .then((apiResponse) => {
        this.setState({ isLoading: false });
        if (apiResponse.data.respCode === 0) {
          sessionStorage.setItem("748784", apiResponse.data.respData.jWT);
          window.location.replace("/dashboard/home");
        } else {
          this.setState({ errDesc: apiResponse.data.respDesc });
        }
      })
      .catch((apiResponse) => {
        this.setState({
          isLoading: false,
          errDesc: apiResponse.response?.statusText || "Error",
        });
      });
  };

  render() {
    const { t, i18n } = this.props;
    const { isLoading, errDesc, Username, Password } = this.state;
    const currentLang = (i18n.language || "en").split("-")[0];

    return (
      <div className="login-page">
        <div className="login-card">
          {/* Logo */}
          <img src={logo} alt="Compounds System" className="login-logo" />

          {/* Titles */}
          <h1 className="login-title">{t("login.welcome")}</h1>
          <p className="login-subtitle">{t("login.subtitle")}</p>

          {/* Error */}
          {errDesc && <div className="login-error">{errDesc}</div>}

          {/* Username */}
          <div className="login-field">
            <label htmlFor="username">
              <FaUser style={{ marginInlineEnd: 6, color: "var(--accent)" }} />
              {t("login.username")}
            </label>
            <input
              id="username"
              type="text"
              className="form-control"
              placeholder={t("login.username")}
              value={Username}
              autoComplete="username"
              onChange={(e) => this.setState({ Username: e.target.value })}
            />
          </div>

          {/* Password */}
          <div className="login-field">
            <label htmlFor="password">
              <FaLock style={{ marginInlineEnd: 6, color: "var(--accent)" }} />
              {t("login.password")}
            </label>
            <input
              id="password"
              type="password"
              className="form-control"
              placeholder={t("login.password")}
              value={Password}
              autoComplete="current-password"
              onChange={(e) => this.setState({ Password: e.target.value })}
            />
          </div>

          {/* Login button */}
          <button
            id="btnLogin"
            className="login-btn"
            disabled={isLoading}
            onClick={this.handleLogin}
          >
            {isLoading ? (
              <>
                <FaSpinner className="fa-spin" />
                {t("login.loggingIn")}
              </>
            ) : (
              <>
                <FaSignInAlt />
                {t("login.loginButton")}
              </>
            )}
          </button>

          {/* Language switcher */}
          <div className="login-lang">
            <button
              className={`lang-btn${currentLang === "en" ? " active" : ""}`}
              onClick={() => this.changeLanguage("en")}
              title="English"
            >
              EN
            </button>
            <button
              className={`lang-btn${currentLang === "ar" ? " active" : ""}`}
              onClick={() => this.changeLanguage("ar")}
              title="العربية"
            >
              AR
            </button>
            <button
              className={`lang-btn${currentLang === "ku" ? " active" : ""}`}
              onClick={() => this.changeLanguage("ku")}
              title="کوردی"
            >
              KU
            </button>
          </div>
        </div>

        <ToastContainer
          position="top-center"
          autoClose={4000}
          hideProgressBar={false}
          closeButton={false}
          rtl={["ar", "ku"].includes(currentLang)}
          transition={Flip}
          newestOnTop
          closeOnClick
          pauseOnVisibilityChange
          draggable
          pauseOnHover
        />
      </div>
    );
  }
}

export default withTranslation()(LoginForm);
